// Only these signed-in users may see the "Reports" tab and use the User Activity
// Reports feature. The backend enforces the same restriction server-side for
// defense-in-depth.
const ALLOWED_REPORTS_EMAILS = [
    'sherwin@dotyeti.com',
    'derek@dotyeti.com',
    'alexyamane@gmail.com',
    'roman@dotyeti.com',
];

export default ALLOWED_REPORTS_EMAILS;
